import { ALL } from '../../../../constants/strings';
import {
  setRouteFilters,
  setStopFilters,
} from '../../../reducers/ui/filterPanel';
import {
  clearSelection,
  updateSelectedStops,
} from '../../../reducers/ui/routeDetail/stopFilters';
import {
  getSelectedRouteFilters,
  getSelectedStopFilters,
} from '../../../selectors/ui/filterPanel';
import {
  getFilteredStopsFromFilterPanel,
  getStopFilters,
} from '../../../selectors/ui/routeDetail';

const getUpdatedFilters = (filters, field, label, values) => {
  const isAll = label === ALL;
  const updated = { ...filters };
  if (isAll || !values.length) {
    delete updated[field];
  } else {
    updated[field] = values;
  }
  return updated;
};

export const onChangeRouteFilter =
  (field, label, values) => (dispatch, getState) => {
    const state = getState();
    dispatch(
      setRouteFilters(
        getUpdatedFilters(getSelectedRouteFilters(state), field, label, values)
      )
    );
  };

export const onChangeStopFilter =
  (field, label, values) => (dispatch, getState) => {
    const state = getState();
    dispatch(
      setStopFilters(
        getUpdatedFilters(getSelectedStopFilters(state), field, label, values)
      )
    );
  };

export const toggleSelectedStopMarker = (stopId) => (dispatch, getState) => {
  const state = getState();
  const { manuallySelectedStops, criteria, filters } = getStopFilters(state);
  if (filters.length || criteria.length) {
    dispatch(clearSelection());
  }
  if (manuallySelectedStops.includes(stopId)) {
    dispatch(
      updateSelectedStops(manuallySelectedStops.filter((id) => id !== stopId))
    );
  } else {
    dispatch(updateSelectedStops([...manuallySelectedStops, stopId]));
  }
};

export const addSelectedStopMarker = (stopId) => (dispatch, getState) => {
  const state = getState();
  const { manuallySelectedStops } = getStopFilters(state);
  dispatch(
    updateSelectedStops([...new Set([...manuallySelectedStops, stopId])])
  );
};

export const selectFilteredStops = () => (dispatch, getState) => {
  const state = getState();
  const filteredStops = getFilteredStopsFromFilterPanel(state);
  const { criteria, filters } = getStopFilters(state);
  if (filters.length || criteria.length) {
    dispatch(clearSelection());
  }
  dispatch(
    updateSelectedStops([...new Set(filteredStops.map(({ stopId }) => stopId))])
  );
};
